import { createAsyncThunk } from '@reduxjs/toolkit';
import OrganizationsResource from 'api/service/OrganizationsResource';

export const getOrganizationBrand = createAsyncThunk(
  'organization/getOrganizationBrand',
  async (initialData, { rejectWithValue }) => {
    const organizationResource = new OrganizationsResource();
    const { id, includes = 'admins' } = initialData;
    const params = { includes };
    const { status, data } = await organizationResource.organization(id).read(params);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Organization-Brand fetching failed.');
  }
);

export const getBrandStat = createAsyncThunk('organization/getBrandStat', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { id } = initialData;
  const { status, data } = await organizationResource.organization(id).getStat();
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Brand stat fetching failed.');
});

export const updateOrganizationBrand = createAsyncThunk(
  'organization/updateOrganizationBrand',
  async (initialData, { rejectWithValue }) => {
    const organizationResource = new OrganizationsResource();
    const { id, payload } = initialData;
    const { status, data } = await organizationResource.organization(id).update(payload);
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Organization-Brand update failed.');
  }
);

export const removeLogo = createAsyncThunk('organization/removeLogo', async (initialData, { rejectWithValue }) => {
  const organizationResource = new OrganizationsResource();
  const { id, type } = initialData;
  const { status } = await organizationResource.organization(id).logo().remove();
  if (status === 202) {
    return { id, type };
  }
  return rejectWithValue('Organization-Logo removal failed.');
});

export const uploadLogoMeta = createAsyncThunk(
  'organization/uploadLogoMeta',
  async (initialData, { rejectWithValue }) => {
    const { id, file } = initialData;
    const organizationResource = new OrganizationsResource();
    const { status, data } = await organizationResource.organization(id).logo().uploadMeta(file);
    if (status === 200) {
      return { status, data };
    }
    return rejectWithValue(id);
  }
);

export const uploadLogoFile = createAsyncThunk(
  'organization/uploadLogoFile',
  async (initialData, { rejectWithValue }) => {
    const { id, uploadUrl, file, logoId, type } = initialData;
    const organizationResource = new OrganizationsResource();
    const { status } = await organizationResource.organization(id).logo().uploadFile(uploadUrl, file);
    if (status === 201) {
      return { id, logoId, type };
    }
    return rejectWithValue(id);
  }
);

export const uploadLogo = createAsyncThunk('organization/uploadLogo', async (initialData, { dispatch }) => {
  const { id, file, type } = initialData;
  const { payload: uploadMetaRes } = await dispatch(uploadLogoMeta({ id, file }));
  if (uploadMetaRes?.status === 200) {
    await dispatch(
      uploadLogoFile({
        id,
        uploadUrl: uploadMetaRes.data.upload_url,
        file,
        logoId: uploadMetaRes.data.oid,
        type,
      })
    );
  }
});
